import angular from 'angular';
import template from './dashboard.html';
import {DashboardController} from './dashboard.controller.js';


export {DashboardController};

const DashboardComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: DashboardController,
    controllerAs: 'vm',
};

export {DashboardComponent};



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.component.js